module.exports = __webpack_public_path__ + "static/media/cq_freccia_destra_b.7b9009bf.svg";